module.exports = {"noPermissionDefault":"Sorry, you do not have permission to access this page"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/en-US/utils.json
// module id = +hU7
// module chunks = 1